import { Component, Inject, OnInit } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { BdcCheckPropertyStatus, BdcContentV2Service } from '@tokeet-frontend/channel-content'
import { BdcCheckPropertyStatusOperation } from '@tokeet-frontend/channel-content'
import { Store } from '@ngrx/store'
import { ActionFailed } from '@tokeet-frontend/tv3-platform'

@Component({
  selector: 'app-bdc-property-summary-dialog',
  templateUrl: './bdc-property-summary-dialog.component.html',
  styleUrls: ['./bdc-property-summary-dialog.component.scss'],
  host: {
    class: 'modal-content',
  },
})
export class BdcPropertySummaryDialogComponent implements OnInit {
  summary: BdcCheckPropertyStatus
  isLoading = true
  constructor(
    public dialogRef: MatDialogRef<BdcPropertySummaryDialogComponent>,
    private store: Store<any>,
    private bdcContentService: BdcContentV2Service,
    @Inject(MAT_DIALOG_DATA) public data: { propertyId: number }
  ) {}

  ngOnInit(): void {
    this.bdcContentService
      .checkPropertyStatus(this.data.propertyId, { operation: BdcCheckPropertyStatusOperation.CHECK })
      .subscribe(
        (sum) => {
          this.isLoading = false
          this.summary = sum
        },
        (error) => {
          this.isLoading = false
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  getText(key: string) {
    if (!this.summary || !this.summary[key] || !this.summary[key].length) {
      return `No ${key} found`
    }
    const items = this.summary[key] || []
    return items
      .map((item, index) => {
        return `${index + 1}. ${item}`
      })
      .join('\n')
  }

  close() {
    this.dialogRef.close()
  }
}
